module.exports = __webpack_public_path__ + "img/share-bg.88849627.jpg";